import { useState } from 'react';
import type { UseQueryResult } from '@tanstack/react-query';
import { Button } from '@/shared/components';
import type { ObjectApartmentSummary, PropertyGroupResponse } from '@/shared/api';
import { WholeFlatLinkFlow } from './WholeFlatLinkFlow';

interface Props {
  propertyId: string;
  propertyName: string;
  /** Apartments desselben Objekts; null, solange die Objektliste fehlt. */
  apartments: ObjectApartmentSummary[] | null;
  manageable: boolean;
}

/** Noch ohne Verbund: Zimmer einer Gesamtwohnung werden oder selbst Zimmer aufnehmen. */
export function UnlinkedApartment({ propertyId, propertyName, apartments, manageable }: Props) {
  const [addingRoom, setAddingRoom] = useState(false);
  if (!manageable) {
    return (
      <p className="text-ink-soft mt-4 text-sm">
        Dieses Apartment gehört zu keinem Wohnungsverbund.
      </p>
    );
  }
  if (!apartments) return null;
  return (
    <>
      <WholeFlatLinkFlow
        key={addingRoom ? 'addRoom' : 'join'}
        mode={addingRoom ? 'addRoom' : 'join'}
        propertyId={propertyId}
        propertyName={propertyName}
        apartments={apartments}
        onCancel={addingRoom ? () => setAddingRoom(false) : undefined}
      />
      {!addingRoom && (
        <Button
          type="button"
          variant="link"
          className="mt-3 min-h-11 whitespace-normal px-0 text-left text-[13px]"
          onClick={() => setAddingRoom(true)}
        >
          Dieses Apartment ist die Gesamtwohnung: Zimmer hinzufügen
        </Button>
      )}
    </>
  );
}

/** Lade- und Fehlerzustand der Objektliste, aus der die Auswahl kommt. */
export function ObjectApartmentsState({
  groups,
}: {
  groups: UseQueryResult<PropertyGroupResponse[]>;
}) {
  if (groups.isError) {
    return (
      <div className="mt-4" role="alert">
        <p className="text-sealwax text-sm">
          Die Apartments des Objekts konnten nicht geladen werden.
        </p>
        <Button
          type="button"
          variant="ghost"
          className="mt-2 min-h-11"
          onClick={() => void groups.refetch()}
        >
          Erneut laden
        </Button>
      </div>
    );
  }
  return <p className="text-ink-soft mt-4 text-sm">Lade die Apartments des Objekts …</p>;
}
